<template>
  <div>
    <v-expansion-panels v-if="totalCheckLists.length" class="elevation-0">
      <v-expansion-panel
        elevation="0"
        flat
        class="elevation-0 border-bottom rounded-0"
        @click="isExpanded = !isExpanded"
      >
        <v-expansion-panel-header hide-actions elevation="0" class="px-2 py-1">
          <div class="d-flex align-center">
            <v-icon color="#2a206a">
              {{ !isExpanded ? 'mdi-menu-right' : 'mdi-menu-down' }}
            </v-icon>
            <span
              class="mt-1 font-weight-bold graphik-font-size-16 dark-purple-text"
            >
              Checklist
              <span class="font-weight-light subtitle-2">
                ({{ totalCheckLists.length }} items)
              </span>
            </span>
          </div>
          <v-spacer></v-spacer>

          <v-btn
            v-show="getAllCheckLists && getAllCheckLists.length"
            @click.stop="openDeleteChecklistCard($event)"
            color="#DCD8F3"
            outlined
            class="shadow text-capitalize mr-12"
            max-width="80"
          >
            <span
              class="dark-purple-text font-weight-bold graphik-font-size-14"
            >
              Delete
            </span>
          </v-btn>
          <v-menu
            v-model="deleteChecklistMenu"
            min-width="250"
            nudge-left="173"
            :position-x="x_coordinate"
            :position-y="y_coordinate"
            nudge-bottom="30"
            offset-y
          >
            <div>
              <v-card class="elevation-0">
                <v-card-title
                  style="border-bottom: 1px solid #dad6f5;"
                  dense
                  class="py-1"
                >
                  <div style="width: 90%;">
                    <div
                      class="font-size-14 font-weight-bold d-flex justify-center dark-purple-text"
                    >
                      Delete Checklist
                    </div>
                  </div>

                  <v-spacer></v-spacer>
                  <div class="d-flex pointer">
                    <v-icon small>mdi-close</v-icon>
                  </div>
                </v-card-title>
                <v-card-text class="py-3">
                  <p style="color: #73819b; line-height: 1.1rem;">
                    Deleting a checklist is permanent and
                    <br />
                    there is no way to get it back.
                  </p>
                  <v-btn
                    depressed
                    @click="deleteCheckList()"
                    color="#C60B2B"
                    class="text-capitalize font-weight-bold white--text w-100 mt-3"
                  >
                    Delete
                  </v-btn>
                </v-card-text>
              </v-card>
            </div>
          </v-menu>
        </v-expansion-panel-header>
        <v-expansion-panel-content
          class="y-scroll"
          :style="
            showField ? 'max-height: calc(20vh + 50px)' : 'max-height: 25vh'
          "
        >
          <!-- Plan div -->
          <div
            style="width: 90%;"
            v-if="hideChecklist"
            class="d-flex align-center"
          >
            <span class="font-size-14 dark-purple-text font-weight-bold">
              Plan
            </span>
            <v-progress-linear
              :color="
                percentageChecked == 100
                  ? '#1CC283'
                  : percentageChecked >= 50
                  ? '#CC64D6'
                  : '#FFAC35'
              "
              background-color="#EDEBF9"
              class="ma-2 rounded"
              :value="percentageChecked"
            ></v-progress-linear>
            <span class="dusty-purple-text caption">
              {{ this.percentageChecked }}%
            </span>
          </div>
          <!-- Checklist -->
          <v-list
            :style="
              $vuetify.breakpoint.xs ? 'max-height:100px' : 'max-height:85px'
            "
            class="y-scroll mb-1"
            v-if="hideChecklist"
            id="list-div"
          >
            <div
              v-for="(item, index) in totalCheckLists"
              :key="index"
              style="width: 90%;"
              class="d-flex align-center"
            >
              <div
                style="
                  word-wrap: break-word;
                  word-break: break-word;
                  max-width: 100%;
                  width: 100%;
                "
                class="d-flex align-start"
              >
                <div class="mt-1">{{ index + 1 }} .</div>
                <v-checkbox
                  :class="item.id == editId ? 'd-none' : 'd-block'"
                  color="#1cc283"
                  id="comment-checkbox"
                  v-model="item.completed"
                  hide-details
                  @click="updateCheckList(item)"
                  dense
                ></v-checkbox>
                <label
                  class="mt-1 graphik-font-size-14"
                  :class="item.id == editId ? 'd-none' : 'd-block'"
                >
                  {{ item.title ? item.title : '' }}
                </label>
                <v-spacer></v-spacer>
                <!-- Edit Checklist Input -->
                <div style="width: 80%;" v-if="item.id == editId">
                  <v-text-field
                    v-if="item.id == editId"
                    autofocus
                    v-model="editCheckbox"
                    color="#73819b"
                    dense
                    hide-details
                    flat
                    solo
                    class="mx-1 caption theme-border"
                    @keydown.enter="updateSingleCheckbox(item)"
                  >
                    <template v-slot:append>
                      <v-icon
                        size="15"
                        color="#2a206a"
                        @click="updateSingleCheckbox(item)"
                      >
                        mdi-check
                      </v-icon>
                    </template>
                  </v-text-field>
                </div>
                <!-- Checklist Actions -->
                <div class="d-flex align-start ml-10 mt-1">
                  <v-menu
                    content-class="shadow elevation-1"
                    min-width="70px"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#2a206a" v-bind="attrs" v-on="on" small>
                        mdi-dots-vertical
                      </v-icon>
                    </template>
                    <v-list class="py-0">
                      <div
                        @click="createTaskCheckbox(item)"
                        class="border-bottom py-1 listing-hover pointer px-2 caption"
                      >
                        Create Task
                      </div>
                      <div
                        @click="editSingleCheckbox(item)"
                        class="border-bottom py-1 listing-hover pointer px-2 caption"
                      >
                        Edit
                      </div>
                      <div
                        @click="deleteSingleCheckbox(item)"
                        class="py-1 listing-hover pointer px-2 caption"
                      >
                        Delete
                      </div>
                    </v-list>
                  </v-menu>
                </div>
              </div>
              <!-- </div> -->
            </div>
          </v-list>

          <!-- Add Item -->
          <div class="d-flex align-center pointer">
            <span
              v-if="!showField"
              @click=";(showField = !showField), (texts = null)"
              class="dusty-purple-text font-size-14 font-family-graphik underline"
            >
              Add Item
            </span>
            <span class="d-flex align-center">
              <v-text-field
                :style="
                  $vuetify.breakpoint.xs
                    ? 'width:50vw'
                    : 'min-width: 140px; width: 244px'
                "
                v-if="showField"
                autocomplete="off"
                autofocus
                class="title-border rounded elevation-0 pl-2 ma-0 graphik-font-size-14 mr-2"
                dense
                flat
                solo
                hide-details=""
                color="#757096"
                placeholder="Add Checkbox"
                v-model="texts"
                @keydown.enter="
                  createCheckBox(texts), (showField = false), (texts = null)
                "
              ></v-text-field>
              <v-btn
                @click="createCheckBox(texts), (showField = false)"
                v-if="showField"
                color="#EDEBF9"
                height="30px"
                width="50px"
                depressed
                class="text-capitalize mx-2"
              >
                <span class="dark-purple-text font-weight-bold">Add</span>
              </v-btn>
              <img
                v-if="showField"
                src="@/assets/images/cancel-icon.svg"
                alt="cancel"
                @click="showField = false"
              />
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- Add Checklist Menu -->
    <v-menu
      v-model="checkListMenu"
      :position-x="x"
      :position-y="y"
      offset-y
      content-class="bg-white shadow"
      min-width="274px"
      min-height="178px"
      :close-on-content-click="false"
    >
      <div :class="[{ edited_scrollbar: isMac }]">
        <!-- Title -->
        <div
          class="text-center dark-purple-text py-2 border-bottom font-weight-bold graphik-font-size-14"
        >
          Add Checklist
        </div>
        <!-- Checklist Title -->
        <div class="mt-2 pa-3">
          <h5 class="dark-purple-text">Title</h5>
          <div class="theme-border rounded mt-2">
            <v-text-field
              background-color="white"
              placeholder="Checklist Title"
              class="graphik-font-size-14"
              color="#757096"
              hide-details
              solo
              flat
              dense
              autofocus
              v-model="checklistTitle"
              autocomplete="off"
              @keydown.enter="
                createCheckBox(checklistTitle)
                checklistTitle = null
              "
            ></v-text-field>
          </div>
        </div>
        <!-- Add Button -->
        <v-btn
          @click="
            editChecklist = true
            createCheckBox(checklistTitle)
            checklistTitle = null
          "
          class="text-capitalize font-weight-bold font-size-14"
          tile
          depressed
          color="#EEF0F6"
          block
        >
          <v-icon color="#2a206a" small>mdi-plus</v-icon>
          <span class="dark-purple-text">Add</span>
        </v-btn>
      </div>
    </v-menu>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { snackbarMixin } from '@/mixins/snackbarMixin'
export default {
  props: ['flag', 'addChecklistMenu', 'taskDetails', 'x', 'y'],
  components: {
    SnackbarNew: () => import('@/components/Includes/SnackbarNew'),
  },
  mixins: [snackbarMixin],
  data() {
    return {
      deleteChecklistMenu: false,
      editCheckbox: null,
      isExpanded: false,
      hideChecklist: true,
      editChecklist: false,
      checklistTitle: null,
      checkListMenu: false,
      texts: null,
      showField: false,
      editId: null,
      x_coordinate: null,
      y_coordinate: null,
    }
  },
  computed: {
    ...mapGetters([
      'getAllCheckLists',
      'getSelectedCompany',
      'getLoggedInUser',
    ]),
    totalCheckLists() {
      var lists = []
      if (this.getAllCheckLists && this.getAllCheckLists.length) {
        for (let list of this.getAllCheckLists) {
          lists = lists.concat(list.checklists)
        }
        return lists
      } else return []
    },
    percentageChecked() {
      var count = 0
      for (let item of this.totalCheckLists) {
        if (item.completed) count = count + 1
      }
      return Math.ceil((count * 100) / this.totalCheckLists.length)
        ? Math.ceil((count * 100) / this.totalCheckLists.length)
        : 0
    },
  },
  methods: {
    createTaskCheckbox(item) {
      if (
        this.taskDetails &&
        this.taskDetails.project &&
        this.taskDetails.project.id
      ) {
        if (item && item.title && item.title.length > 2) {
          let body = {
            company_id: this.getSelectedCompany.id,
            due_date: '',
            duration: '',
            end_time: '',
            future_task: false,
            members: [],
            project_id: this.taskDetails.project.id,
            self_assigned: false,
            start_time: '',
            status: 'pending',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            title: item.title,
          }
          this.$store.dispatch('createTaskCheckbox', body)
        } else
          this.openSnackbar(true, 'Title must be greater than 2 characters')
      } else this.openSnackbar(true, 'Please select project')
    },
    updateCheckList(list) {
      let body = {
        task_id: this.taskDetails.task_id,
        company_id: this.getSelectedCompany.id,
        checklist_id: list.checklist_id,
        checklists: this.getAllCheckLists
          .find((item) => {
            return item.id == list.checklist_id
          })
          .checklists.filter((item) => {
            return item.id != list.id
          })
          .concat([list]),
      }
      this.$store.dispatch('updateCheckList', body)
    },
    fetchCheckList(taskDetails) {
      let body = {
        company_id: this.getSelectedCompany.id,
        task_id: taskDetails && taskDetails.task_id,
      }
      this.$store.dispatch('fetchCheckList', body)
    },
    createCheckBox(argument) {
      if (argument != null) {
        if (argument.length > 200) {
          this.openSnackbar(
            true,
            'Title may not be greater than 200 characters.',
          )
        } else {
          var user = this.getAllCheckLists.find((item) => {
            return item.user_id == this.getLoggedInUser.id
          })
          let body = {
            task_id: this.taskDetails.task_id,
            company_id: this.getSelectedCompany.id,
            checklist_id:
              user != undefined && user.checklists && user.checklists.length
                ? user.checklists[0].checklist_id
                : '',
            checklists:
              user != undefined
                ? user.checklists.concat([
                    { id: Date.now(), title: argument, completed: false },
                  ])
                : [{ id: Date.now(), title: argument, completed: false }],
          }
          this.$store
            .dispatch('addCheckList', body)
            .then((res) => {
              this.openSnackbar(false, res.data.error_msg)
            })
            .catch(() => {
              this.openSnackbar(true, 'Enter Title To Create Checkbox.')
            })
        }
      } else {
        this.openSnackbar(true, 'Enter Title To Create Checkbox')
      }

      //this.checkbox.push({ name: argument, value: false });
      return
    },
    openDeleteChecklistCard(event) {
      event.stopPropagation()
      this.x_coordinate = event.clientX
      this.y_coordinate = event.clientY
      this.deleteChecklistMenu = true
    },
    deleteCheckList() {
      let body = {
        task_id: this.taskDetails.task_id,
        company_id: this.getSelectedCompany.id,
      }
      this.$store.commit('setRemoveCheckLists')
      this.$store
        .dispatch('deleteCheckList', body)
        .then(() => {
          this.deleteChecklistMenu = false
        })
        .catch((error) => {
          this.openSnackbar(true, error)
        })
    },
    deleteSingleCheckbox(list) {
      var array = []
      array = this.getAllCheckLists
        .find((item) => {
          return item.id == list.checklist_id
        })
        .checklists.filter((item) => {
          return item.id != list.id
        })
      let body = {
        task_id: this.taskDetails.task_id,
        company_id: this.getSelectedCompany.id,
        checklist_id: list.checklist_id,
        checklists: array,
      }
      if (array.length == 0) {
        this.$store.commit('setDeleteCheckboxLoginUser', {
          user_id: this.getAllCheckLists.find((item) => {
            return item.id == list.checklist_id
          }).user_id,
        })
        this.$store.dispatch('deleteCheckList', {
          task_id: this.taskDetails.task_id,
          company_id: this.getSelectedCompany.id,
          checklist_id: list.checklist_id,
        })
      } else {
        this.$store.commit('setDeleteSingleCheckbox', {
          checklist_id: list.checklist_id,
          list_id: list.id,
          array: array,
        })
        this.$store.dispatch('deleteSingleCheckBox', body)
      }
    },
    editSingleCheckbox(list) {
      this.editId = list.id
      this.editCheckbox = list.title
    },
    updateSingleCheckbox(list) {
      if (this.editCheckbox.trim()) {
        if (this.editCheckbox.length > 200)
          this.openSnackbar(
            true,
            'Title may not be greater than 200 characters.',
          )
        else {
          var array = []
          array = this.getAllCheckLists.find((item) => {
            return item.id == list.checklist_id
          }).checklists
          var id = this.getAllCheckLists
            .find((item) => {
              return item.id == list.checklist_id
            })
            .checklists.findIndex((item) => {
              return item.id == list.id
            })
          Object.assign(array[id], {
            title: this.editCheckbox,
            completed: list.completed,
            checklist_id: list.checklist_id,
            id: list.id,
          })
          let body = {
            task_id: this.taskDetails.task_id,
            company_id: this.getSelectedCompany.id,
            checklist_id: list.checklist_id,
            checklists: array,
          }
          this.$store.commit('setDeleteSingleCheckbox', {
            checklist_id: list.checklist_id,
            list_id: list.id,
            array: array,
          })
          this.editId = null
          this.$store.dispatch('updateCheckList', body)
        }
      } else this.openSnackbar(true, 'Minimum word limit is 1 character')
    },
  },
  watch: {
    addChecklistMenu(value) {
      if (value) this.checkListMenu = true
    },
    checkListMenu(value) {
      if (!value) {
        this.$emit('update:addChecklistMenu', false)
        this.$emit('update:x', null)
        this.$emit('update:y', null)
      }
    },
  },
}
</script>
<style scoped>
.v-input--selection-controls {
  margin-top: 3px !important;
  padding-top: 2px !important;
  font-size: 4px !important;
}
.graphik-font-size-14 {
  font-family: 'Graphik-Font-Family' !important;
  font-size: 14px;
}
.graphik-font-size-16 {
  font-family: 'Graphik-Font-Family' !important;
  font-size: 16px;
}
</style>
